import React from "react";

export default function ContractIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.65063 10.3681C7.78554 9.50781 7.25 8.31645 7.25 7C7.25 5.68355 7.78554 4.49219 8.65063 3.63188C8.15256 3.38733 7.59232 3.25 7 3.25C4.92893 3.25 3.25 4.92893 3.25 7C3.25 9.07107 4.92893 10.75 7 10.75C7.59232 10.75 8.15256 10.6127 8.65063 10.3681Z"
        fill="#A6B0CF"
      />
      <path
        d="M8.25 7C8.25 4.92893 9.92893 3.25 12 3.25C14.0711 3.25 15.75 4.92893 15.75 7C15.75 9.07107 14.0711 10.75 12 10.75C9.92893 10.75 8.25 9.07107 8.25 7Z"
        fill="#A6B0CF"
      />
      <path
        d="M15.3494 3.63188C16.2145 4.49219 16.75 5.68355 16.75 7C16.75 8.31645 16.2145 9.50781 15.3494 10.3681C15.8474 10.6127 16.4077 10.75 17 10.75C19.0711 10.75 20.75 9.07107 20.75 7C20.75 4.92893 19.0711 3.25 17 3.25C16.4077 3.25 15.8474 3.38733 15.3494 3.63188Z"
        fill="#A6B0CF"
      />
      <path
        d="M5.25 16C5.25 13.9289 6.92893 12.25 9 12.25H15C17.0711 12.25 18.75 13.9289 18.75 16C18.75 18.0711 17.0711 19.75 15 19.75H9C6.92893 19.75 5.25 18.0711 5.25 16Z"
        fill="#A6B0CF"
      />
      <path
        d="M0.25 15C0.25 12.9289 1.92893 11.25 4 11.25H9C6.37665 11.25 4.25 13.3766 4.25 16C4.25 17.0249 4.57458 17.9739 5.12655 18.75H4C1.92893 18.75 0.25 17.0711 0.25 15Z"
        fill="#A6B0CF"
      />
      <path
        d="M19.75 16C19.75 17.0249 19.4254 17.9739 18.8734 18.75H20C22.0711 18.75 23.75 17.0711 23.75 15C23.75 12.9289 22.0711 11.25 20 11.25H15C17.6234 11.25 19.75 13.3766 19.75 16Z"
        fill="#A6B0CF"
      />
    </svg>
  );
}
